import { logger } from './logger'

const messages = require('@/assets/json/messages.json')

export interface MessageProviderInterface {
  get(...arg: any[]): string
}

const defaultMessage = 'エラーが発生しました。'

export class MessageProvider implements MessageProviderInterface {

  /**
   * メッセージIDに応じたメッセージ文字列を取得します
   *
   * @param messageId string メッセージのID
   * @param args any[] メッセージ内に置換要素が含まれる場合の値（置き換え要素は文字列を推奨します）
   * @return string メッセージ文字列
   */
  public get(messageId: string, ...args: any[]): string {

    const template: string = messages[messageId]
    if(template === undefined) {
      // TODO: DEV_EL2ND-720 : 対象メッセージが見つからない場合の処理方法を検討 (【非機能要件】全画面共通の異常系処理)
      logger.error('unknown message id : ' + messageId)
      return defaultMessage
    }

    // 引数が無い場合は、そのまま返す
    if(args.length === 0) {
      return template
    }

    // パラメータ置き換え
    return args.reduce((prev: string, current: string, index: number) => {
      return prev.replace(new RegExp(`\\{${index}\\}`, 'g'), current)
    }, template)
  }
}

// eslint-disable-next-line import/no-mutable-exports
let messageProvider: MessageProviderInterface
export function initializeMessageProvider(messageProviderInstance: MessageProviderInterface) {
  messageProvider = messageProviderInstance
}

export { messageProvider }
